import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'

export default {
	/**
	 * 首页数据展示
	**/
	dasboardData() {
		return request({
	    url: baseUrl + '/dasboard/index',
	    method: 'GET'
	  })
	},

	/**
	 * 首页灯的状态
	**/
	getLightInfo() {
		return request({
	    url: baseUrl + '/getLightInfo',
	    method: 'GET'
	  })
	},
	
	/**
	 * 日志列表接口
	**/
	getCommand(data) {
		return request({
			url: baseUrl + '/dasboard/getCommandHistory?platform='+data,
			method: 'GET'
	  })
	},

	/**
	 * 得到最新的一条日志
	**/
	getHistory(data) {
		return request({
	    url: baseUrl + '/dasboard/getHistoryFirst?platform='+data,
	    method: 'GET'
	  })
	},

	/**
	 * 策略列表接口
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	strategyList( params={} ) {
		return request({
	    url: baseUrl + '/GatewayStrategy',
	    method: 'GET',
	    params
	  })
	},

	/**
	 * 策略添加接口
	**/
	strategyAdd(data) {
		return request({
	    url: baseUrl + '/GatewayStrategy',
	    method: 'POST',
	    data
	  })
	},
	/**
	 * 策略编辑接口
	**/
	strategyEdit(id,data){
		return request({
			url: baseUrl + '/GatewayStrategy/'+id,
			method:'PUT',
			data
		})
	},
	/**
	 * 策略删除接口
	**/
	strategyDel(id){
		return request({
			url: baseUrl + '/GatewayStrategy/'+id,
			method:'DELETE'
		})
	},

	/**
	 * 命令下发 -下发立即策略命令 1
	**/
	sendGatewayStrategy(data) {
		return request({
	    url: baseUrl + '/sendGatewayStrategy',
	    method: 'POST',
	    data
	  })
	},

	/**
	 * 命令下发 -下发定时策略命令 0
	**/
	sendUsuallyStrategy(data) {
		return request({
	    url: baseUrl + '/sendUsuallyStrategy',
	    method: 'POST',
	    data
	  })
	},
}